'use strict';
import { Component, Inject, Input, EventEmitter, Output} from 'ng-metadata/core';
import { MappingTablesCache } from '../../../mappingTablesCache/mappingTablesCache.service';
import { ExportAllService } from './exportAll.service';
import { getVid } from "../../../appConfig/appConfigForward";
import { MediaQueries } from '../../../infra/mediaQueries.service';
import { ChangeLangService } from '../../../infra/lang/changeLang.service';

const isEqual = require('lodash/isEqual');


@Component({
    "selector": 'prm-export-all',
    templateUrl: 'components/search/actions/exportAll/export-all.html'
})


export class PrmExportAll{
    @Input() private totalResults: number;
    @Output() private closeModal = new EventEmitter<void>();

    private _exportOptionsList: string[];
    private _encodingList: string[];
    private _formatList: string[] = ['xlsx','csv'];
    private valuesToFilter: string[] = [this.exportAllService.EXCEL,this.exportAllService.RISPUSHTO,this.exportAllService.BIBTEXPUSHTO];

    private KEY_CODE = {
        COMMA: 188,
        SEMICOLON: 186,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT_ARROW: 37,
        UP_ARROW: 38,
        RIGHT_ARROW: 39,
        DOWN_ARROW: 40,
        TAB: 9,
        BACKSPACE: 8,
        DELETE: 46
    };

    constructor(
                private mappingTablesCache: MappingTablesCache,
                private exportAllService: ExportAllService,
                private mediaQueries: MediaQueries,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private changeLangService: ChangeLangService
                ){

            this.setExportOptionsList();
            this.setEncodingValues();
            
    }

    get secondDropDownValues(){
        return this.exportOption=== "Excel" ?  this.formatTypes : this.encodingList;
    }

    get exportOption() {
        return this.exportAllService.exportOption;
    }

    set exportOption(val){
        this.exportAllService.exportOption = val;
    }

    get encodingOrFormatVal() {
        return this.exportAllService.encodingOrFormatVal;
    }

    set encodingOrFormatVal(val){
        this.exportAllService.encodingOrFormatVal = val;
    }

    get exportOptionsList() {
        return this._exportOptionsList;
    }

    get encodingList() {
        return this._encodingList;
    }

    get formatTypes(){
        return this._formatList;
    }

    get totalResultsNum(){
        return this.totalResults;
    }

    private setEncodingValues() {
        let rows = this.mappingTablesCache.getTable(this.mappingTablesCache.tables.EXPORT_RIS_ENCODINGS);
        if (rows.length> 0){
            this._encodingList = rows.map((r)=>{return r.source1;});
        }
    }

    private setExportOptionsList(){
        let rows = this.mappingTablesCache.getTable(this.mappingTablesCache.tables.ACTIONS_LIST);
        let actionsPerViewOrDefaultView = rows.filter((val) => val['target'] === getVid());
        rows = actionsPerViewOrDefaultView.length ? actionsPerViewOrDefaultView : rows.filter((val) => val['target'] === 'default');
        if (rows.length> 0){
            const filteredArray = rows.filter(r => this.valuesToFilter.includes(r.source1));
            filteredArray.sort((a, b) => parseInt(a.source2) - parseInt(b.source2));    // Sort the array by source2 value ("order")
            this._exportOptionsList = filteredArray.map(obj => obj.source1);
            if (filteredArray.length == 1){ //In case only one export option is enabled, it will be automatically selected
                this.exportAllService.exportOption = this._exportOptionsList[0];
            }
        }
    }

    get labelToTranslate(){
        return isEqual(this.exportOption, this.exportAllService.EXCEL) ? this.$translate.instant('fulldisplay.command.pushto.option.Excel.FileType') 
                : this.$translate.instant('fulldisplay.command.pushto.option.RISPushTo.encoding');
    }

    get ariaLabelToTranslate(){
        return isEqual(this.exportOption, this.exportAllService.EXCEL) ? this.$translate.instant('aria.fulldisplay.command.pushto.option.Excel.FileType')
                : this.$translate.instant('nui.aria.exportTo.encoding');
    }

    private throwCloseTabsEvent(isAfterEmailSent: boolean){
        this.exportAllService.resetExportAllSelection();
        this.closeModal.emit(null); //throw this event to signal to searchResultToolBar directive that you want to close the open action tab

        /* Close the search result toolbar after clickign "send" */
        if (isAfterEmailSent){
            let elem = document.querySelector("prm-search-result-tool-bar .floated-max-results-message") as HTMLElement;
            if (elem) {
                let dir = (this.changeLangService.direction) === 'ltr' ? 'left' : 'right';
                angular.element(elem).css(dir, '-100%');  
            }  
        }
    }


    public keyDownSupport(e) {
        let keyCodes = this.KEY_CODE;
        if (e.keyCode === keyCodes.TAB) {
            e.preventDefault();
            e.stopPropagation();
            if (e.shiftKey){ //need to go backwards
                this.focusBackwards();  
            } else {
                this.focusChangeFormatDropdown();
            }    
        }
    }

    private focusChangeFormatDropdown() {
        let element = document.getElementById('exportAllFormatDropdown');
	    if (element) {
			element.focus();
		}
	}

    private focusBackwards() {
        let element = document.getElementById('emailSectionSendButton');
	    if (element) {
			element.focus();
		} else {
            this.focusChangeFormatDropdown();
        }
	}
}







// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/exportAll/exportAll.directive.ts